import Overview from "@/features/Overview";
import WeeklySchedule from "@/features/WeeklySchedule";
import DailyQuestions from "@/features/DailyQuestions";
import Resources from "@/features/Resources";
import UnitCompletion from "@/features/UnitCompletion";
import PPPD from "@/features/PPPD";
import StudyProgram from "@/features/StudyProgram";
import WeakTopics from "@/features/WeakTopics";
import BranchExams from "@/features/BranchExams";
import GeneralExams from "@/features/GeneralExams";
import Targets from "@/features/Targets";
import Preferences from "@/features/Preferences";
import TrackingCard from "@/features/TrackingCard";
import ResourceProgram from "@/features/ResourceProgram";
import DetailedExams from "@/features/DetailedExams";
import OpticalResults from "@/features/OpticalResults";
import TopicTracker from "@/features/TopicTracker";
import MathCamp from "@/features/MathCamp";
import StudentLibrary from "@/features/StudentLibrary";
import {
  LayoutDashboard, CalendarDays, ListChecks, BookOpen, GitBranch,
  Brain, AlertTriangle, FlaskConical, BarChart3, Target, CalendarCheck, ListOrdered, ClipboardCheck, NotebookText, FileText, Award, BookMarked, Tent, Library,
} from "lucide-react";

export const WORKSPACE_TABS = [
  { id: "overview", label: "Genel Bakış", icon: LayoutDashboard },
  { id: "schedule", label: "Haftalık Program", icon: CalendarDays },
  { id: "study-program", label: "Çalışma Programı", icon: CalendarCheck },
  { id: "daily", label: "Günlük Soru", icon: ListChecks },
  { id: "resources", label: "Kaynak Takibi", icon: BookOpen },
  { id: "mylibrary", label: "Kaynak Kütüphanesi", icon: Library },
  { id: "units", label: "Ünite/Konu", icon: GitBranch },
  { id: "topics", label: "Konu Takibi", icon: BookMarked },
  { id: "camp", label: "Matematik Kampı", icon: Tent },
  { id: "pppd", label: "PPD Takibi", icon: Brain },
  { id: "weak", label: "Zayıf Konular", icon: AlertTriangle },
  { id: "tracking", label: "Takip Kartı", icon: ClipboardCheck },
  { id: "branch", label: "Branş Deneme", icon: FlaskConical },
  { id: "general", label: "Genel Deneme", icon: BarChart3 },
  { id: "detailed", label: "Detaylı Karne", icon: FileText },
  { id: "optresults", label: "Sınav Sonuçları", icon: Award },
  { id: "targets", label: "Hedef Net", icon: Target },
  { id: "preferences", label: "Tercih Robotu", icon: ListOrdered },
];

export default function StudentWorkspace({ studentId, studentName, track, readOnly, tab }) {
  const p = { studentId, readOnly, track };
  switch (tab) {
    case "overview": return <Overview studentId={studentId} studentName={studentName} track={track} />;
    case "schedule": return <WeeklySchedule {...p} />;
    case "study-program": return <StudyProgram {...p} />;
    case "daily": return <DailyQuestions {...p} />;
    case "resources": return <Resources {...p} />;
    case "mylibrary": return <StudentLibrary {...p} />;
    case "autores": return <ResourceProgram {...p} />;
    case "units": return <UnitCompletion {...p} />;
    case "topics": return <TopicTracker {...p} />;
    case "camp": return <MathCamp {...p} />;
    case "pppd": return <PPPD {...p} />;
    case "weak": return <WeakTopics studentId={studentId} readOnly={readOnly} />;
    case "tracking": return <TrackingCard studentId={studentId} readOnly={readOnly} />;
    case "branch": return <BranchExams {...p} />;
    case "general": return <GeneralExams {...p} />;
    case "detailed": return <DetailedExams studentId={studentId} readOnly={readOnly} />;
    case "optresults": return <OpticalResults studentId={studentId} studentName={studentName} track={track} readOnly={readOnly} />;
    case "targets": return <Targets {...p} />;
    case "preferences": return <Preferences {...p} />;
    default: return null;
  }
}
